module.exports = __webpack_public_path__ + "img/services-1.ac9cf5c9.png";